var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 107 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .121h47.532v68.786H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.121.177h10.176v22.26H.121z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 53.5,
    cy: 53.5,
    r: 53.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F4F8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.55 46.636l12.203-31.767a5.345 5.345 0 0110.055 3.624L44.725 51.469",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.032 51.572l-.615-.206L55.501 18.39a4.986 4.986 0 00-.266-3.84 4.988 4.988 0 00-2.907-2.524 5.015 5.015 0 00-6.273 2.96L33.852 46.752l-.605-.232 12.204-31.767a5.66 5.66 0 017.082-3.342 5.63 5.63 0 013.282 2.85 5.632 5.632 0 01.3 4.335L45.032 51.572z",
    fill: "#18122B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.887 44.906L30.695 18.322a5.345 5.345 0 019.614-4.67l14.504 28.283a5.345 5.345 0 004.617 2.904l9.143.239c2.897.075 4.748 2.445 4.748 5.343v19.167c0 6.398-6.702 9.292-6.702 9.292l-31.708-.32s-5.459-4.946-6.312-10.064c-.545-3.272-1.509-12.054-2.133-17.962a5.203 5.203 0 015.174-5.75h12.91a5.203 5.203 0 110 10.406h-7.902s9.227 1.708 8.692 12.454",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.113 10.298)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.927 67.94l31.51.318c.656-.307 6.447-3.18 6.447-8.968V40.124c0-2.888-1.822-4.952-4.432-5.02l-9.143-.239a5.667 5.667 0 01-4.897-3.08L13.908 3.503a5.014 5.014 0 00-6.552-2.278 4.988 4.988 0 00-2.622 2.818 4.988 4.988 0 00.143 3.846l12.048 26.273h1.511a5.533 5.533 0 015.528 5.527 5.533 5.533 0 01-5.528 5.527h-5.915c2.747 1.192 7.417 4.373 7.03 12.146l-.647-.031c.515-10.344-8.339-12.104-8.428-12.12l.059-.643h7.901c2.69 0 4.88-2.189 4.88-4.879 0-2.69-2.19-4.88-4.88-4.88H5.527A4.886 4.886 0 001.9 36.426a4.887 4.887 0 00-1.225 3.777c.679 6.43 1.6 14.761 2.13 17.943.766 4.592 5.418 9.132 6.122 9.796zm31.644.967l-31.9-.321-.09-.083c-.227-.205-5.553-5.082-6.414-10.251C1.634 55.054.71 46.708.03 40.27a5.536 5.536 0 011.388-4.278 5.536 5.536 0 014.109-1.83h10.686L4.288 8.16a5.632 5.632 0 01-.162-4.343A5.632 5.632 0 017.088.636a5.66 5.66 0 017.396 2.57L28.988 31.49a5.02 5.02 0 004.338 2.729l9.142.238c2.935.077 5.064 2.46 5.064 5.668V59.29c0 6.535-6.83 9.56-6.898 9.59l-.063.027z",
    fill: "#18122B",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.385 61.544h-.388a4.57 4.57 0 01-4.57-4.57V40.07c0-.148.938 1.724.952 1.58.222-2.318 1.243-5.834 3.618-5.834h.388a4.57 4.57 0 014.57 4.57v16.587a4.57 4.57 0 01-4.57 4.57m9.741-.685h-.388a4.57 4.57 0 01-4.57-4.57V43.816a4.57 4.57 0 014.57-4.57h.388a4.57 4.57 0 014.57 4.57v12.472a4.57 4.57 0 01-4.57 4.57",
    fill: "#DFDDE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.03 59.61h-.388a4.57 4.57 0 01-4.57-4.571V38.453a4.57 4.57 0 014.57-4.57h.388a4.57 4.57 0 014.57 4.57v16.586a4.57 4.57 0 01-4.57 4.57",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.642 34.207a4.251 4.251 0 00-4.246 4.246v16.586a4.251 4.251 0 004.246 4.246h.388a4.251 4.251 0 004.247-4.246V38.453a4.251 4.251 0 00-4.247-4.246h-.388zm.388 25.726h-.388a4.9 4.9 0 01-4.894-4.894V38.453a4.9 4.9 0 014.894-4.894h.388a4.9 4.9 0 014.894 4.894v16.586a4.9 4.9 0 01-4.894 4.894z",
    fill: "#18122B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.77 58.923h-.388a4.57 4.57 0 01-4.57-4.57V41.881a4.57 4.57 0 014.57-4.57h.389a4.57 4.57 0 014.57 4.57v12.472a4.57 4.57 0 01-4.57 4.57",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.367 36.81)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.015.825A4.25 4.25 0 00.769 5.07v12.472a4.25 4.25 0 004.246 4.247h.388a4.25 4.25 0 004.246-4.247V5.071A4.25 4.25 0 005.403.825h-.388zm.388 21.612h-.388a4.9 4.9 0 01-4.894-4.894V5.071A4.9 4.9 0 015.015.177h.388a4.9 4.9 0 014.894 4.894v12.472a4.9 4.9 0 01-4.894 4.894z",
    fill: "#18122B",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M70.48 103.576l-.77-26.28-36.774 1.631v25.175z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.26 79.237v24.536l36.887-.516-.75-25.624-36.138 1.604zm-.648 25.193V78.617l37.413-1.66.789 26.938-38.202.535z",
    fill: "#18122B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDDE6",
    d: "M70.33 110.645l-.77-26.281-36.28 1.702v25.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18122B",
    d: "M72.67 119.19l-.927-31.652-41.206 1.496v30.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.185 89.659v29.044l40.817-.158-.888-30.336-39.929 1.45zm-1.297 30.345l.001-31.595 42.482-1.542.966 32.968-43.449.169z",
    fill: "#18122B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.81 95.923a2.11 2.11 0 11-2.41-3.465 2.11 2.11 0 012.41 3.465",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.602 92.404a1.788 1.788 0 00-1.463 2.807 1.788 1.788 0 003.225-.705c.084-.47-.02-.944-.292-1.335a1.775 1.775 0 00-1.47-.767m.007 4.22a2.433 2.433 0 11.426-4.83c.64.116 1.197.473 1.569 1.007.371.533.512 1.18.397 1.82a2.418 2.418 0 01-1.005 1.568 2.422 2.422 0 01-1.387.435",
    fill: "#18122B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDDE6",
    d: "M38.168 35.512l4.137 8.91-1.75.032-2.928-7.478zm11.496 12.376c1.574 4.587-1.971 7.597-4.845 7.597h-6.891s7.665 1.237 7.774 11.996c-.099-9.775-4.311-11.933-4.311-11.933h4.414c2.874 0 4.627-1.634 5.05-3.515.322-1.435-.21-3.199-1.19-4.145"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromise);
export default __webpack_public_path__ + "static/media/promise.ad124a1a.svg";
export { ForwardRef as ReactComponent };